module.exports = __webpack_public_path__ + "static/media/gm.5bbf7b74.svg";